import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import {Box, Grid} from '@material-ui/core'
import {makeStyles} from "@material-ui/core/styles";
import calender from '../../../assests/images/Vectorcalender.svg'
import time from '../../../assests/images/Vectortime.svg'
import moment from "moment-timezone";
import Link from "react-router-dom/es/Link";
import {BUTTON_STATE} from "../../../constant";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    breadCrumb: {
        color: '#fff',
        paddingRight: '36px',
        fontSize: '14px',
        lineHeight:'22px',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover':{
            textDecoration: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '12px',
            lineHeight: '24px'
        },
    },
    text: {
        marginTop: '15px',
        fontSize: '32px',
        lineHeight: '37.5px',
        fontFamily: 'Roboto',
        marginBottom: '10px',
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            fontSize: '24px',
            lineHeight: '28px',
        },
    },
    schedule: {
        fontFamily: 'Manrope',
        letterSpacing: '0.11px',
        marginRight: '28px',
    },
    scheduleImg: {
        marginRight: '15px',
        verticalAlign: 'sub'
    },
    timeWrrapper: {
        [theme.breakpoints.down('xs')]: {
            display: 'block',
            margin: '0 0 10px'
        },
    },
    playerTitle: {
        backgroundColor: '#FF4842',
        padding: '1px 8px',
        width: '48px',
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
        marginTop: '24px'
    }
}));

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function PlayerInfo(props) {
    console.log('props===========', props);
    const{sessionData, videoObj} = props;
    const classes = useStyles();
  return (
    <Box>
        <Breadcrumbs aria-label="breadcrumb">
        <Link color="inherit" to={`/schedule`}  className={classes.breadCrumb} style={{opacity: '0.5'}}>
            SCHEDULE
        </Link>
        <Link color="inherit" to={{}} className={classes.breadCrumb}>
            {sessionData.location}
        </Link>
        </Breadcrumbs>
        <Box>
            <Typography className={classes.playerTitle} component="p">{videoObj.type == BUTTON_STATE.VOD ? 'VOD' : 'LIVE'}</Typography>
            <Typography component="p" className={classes.text}>{sessionData.title}</Typography>
            <Grid item xs={12} md={8} className=''>
                <span className={classes.timeWrrapper}><img src={calender} alt="Calendar" className={classes.scheduleImg} /> <Typography component={'span'} className={classes.schedule}>{moment(sessionData.startDate).format("dddd MMM D")}</Typography></span>
                <span className={classes.timeWrrapper}><img src={time} alt="time" className={classes.scheduleImg} /> <Typography component={'span'} className={classes.schedule}>{`${moment(sessionData.startDate).format('h:mma')} - ${moment(sessionData.endDate).format('h:mma')} ${moment.tz(moment.tz.guess()).zoneAbbr()}`}</Typography></span>
            </Grid>
        </Box>
    </Box>  
  );
}